// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IDJe","left":"styles_left__2j_zV"};